import React, { useState, useEffect, useContext } from 'react';
import './generateAIportal.scss';
import { useTranslation } from '../../../contexts/TranslationProvider';
import { getName } from '../../../helpers/Translation';
import { ContractTemplateEntity, ClauseEntity } from '../../../domain/entities';
import EditContractTemplateContext from "../../../contexts/EditContractTemplateContext";
import { RiEditBoxFill, RiEyeFill } from 'react-icons/ri';
import { BiEdit } from 'react-icons/bi';
import { BsEye } from 'react-icons/bs';

const ContractTemplateGroups = ({ groups, close, onSelectGroup, clauseIndex }: {
  onSelectGroup: (index: string, groups: ContractTemplateEntity['groups'], viewGroups?: ContractTemplateEntity['groups']) => void;
  close: () => void;
  clauseIndex: ClauseEntity['index'];
  groups: ContractTemplateEntity['groups'];

}) => {
  const { groups: originalGroups } = useContext(EditContractTemplateContext);
  const [groupsSelected, setGroupsSelected] = useState<ContractTemplateEntity['groups']>([]);
  const [viewGroupsSelected, setViewGroupsSelected] = useState<ContractTemplateEntity['groups']>([]);
  const { t, language } = useTranslation();
  const translationPath = "pages.contractTemplateParam.addGroups";

  const handleChange = (e, groupSelected) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const newSelectedGroup = [...groupsSelected, groupSelected];
      const newViewSelectedGroup = viewGroupsSelected.filter(group => group.id !== groupSelected.id);
      onSelectGroup(clauseIndex, newSelectedGroup, newViewSelectedGroup);
    } else {
      const newSelectedGroup = groupsSelected.filter(group => group.id !== groupSelected.id);
      onSelectGroup(clauseIndex, newSelectedGroup, viewGroupsSelected);
    }
  };
  const handleChangeView = (e, groupSelected) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const newViewSelectedGroup = [...viewGroupsSelected, groupSelected];
      const newSelectedGroup = groupsSelected.filter(group => group.id !== groupSelected.id);

      onSelectGroup(clauseIndex, newSelectedGroup, newViewSelectedGroup);
    } else {
      const newViewSelectedGroup = viewGroupsSelected.filter(group => group.id !== groupSelected.id);
      onSelectGroup(clauseIndex, groupsSelected, newViewSelectedGroup);
    }
  };


  useEffect(() => {
    if (groups) {
      const newSelectedGroup = groups.filter(group =>
        group.Group_ContractTemplate?.clauseCodes?.some(code => code === clauseIndex)
      );
      const newViewSelectedGroup = groups.filter(group =>
        group.Group_ContractTemplate?.viewClauseCodes?.some(code => code === clauseIndex)
      );
      setGroupsSelected(newSelectedGroup)
      setViewGroupsSelected(newViewSelectedGroup)
    } else {
      setGroupsSelected([]);
    }
  }, [clauseIndex, JSON.stringify(groups)]);

  return (
    <div>
      <div className="generate-ai-portal" style={{ marginTop: "" }}>
        <div className="generate-ai-portal-header">
          <span className='close-dialog' onClick={() => close()}>X</span>
        </div>
        <div className="generate-ai-portal-content">
          <div className="generate-ai-portal-content-checkbox">
            <BiEdit style={{ width: 14, height: 14 }} />
            <BsEye style={{ width: 14, height: 14 }} />
            <label className='generate-ai-portal-label' >{ }</label>
          </div>
          {groups.map((group, index) => {
            const isChecked = groupsSelected.some(selectedGroup =>
              selectedGroup.id === group.id &&
              selectedGroup.Group_ContractTemplate?.clauseCodes?.some(code => code === clauseIndex)
            );
            const isViewChecked = viewGroupsSelected.some(selectedGroup =>
              selectedGroup.id === group.id &&
              selectedGroup.Group_ContractTemplate?.viewClauseCodes?.some(code => code === clauseIndex)
            );
            const originalGrp = originalGroups.find(g => g.id === group.id);
            return (
              <div key={index} className="generate-ai-portal-content-checkbox">
                <input
                  type="checkbox"
                  id={String(group.id)}
                  name={group.name}
                  checked={isChecked}
                  onChange={(e) => handleChange(e, group)}
                />
                <input
                  type="checkbox"
                  id={String(group.id)}
                  name={group.name}
                  checked={isViewChecked}
                  onChange={(e) => handleChangeView(e, group)}
                />
                <label className='generate-ai-portal-label' htmlFor={String(group.id)}>{getName(originalGrp, language)}</label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ContractTemplateGroups;
